export function isOrderAvailable(item, manualAvailability = item?.isAvailable, now = Date.now()) {
  return Boolean(manualAvailability) && item?.canOrder !== false &&
    (!item?.availabilityValidUntil || now < Date.parse(item.availabilityValidUntil));
}
